
import { isEmpty, split, head, isNil, get } from 'lodash';
import { required, email, minValue, maxValue, numeric, decimal, alpha, alphaNum, integer, helpers, minLength, maxLength } from 'vuelidate/lib/validators';
import ValidateMixin from './ValidateMixin';

// define a mixin object
export default {
  mixins: [ValidateMixin],

  props: {
    validate: {
      default: null,
      required: false,
      type: String,
    },
    label: {
      default: null,
      required: false,
      type: String,
    },
    name: {
      default: null,
      required: false,
      type: String,
    },
    validateField: {
      default: 'value',
      required: false,
      type: String,
    },
  },

  validations() {
    return {
      [this.validateField]: this.__validations,
    };
  },

  created() {
    this.$serviceBus.$on('validate', this.validate);
  },

  beforeDestroy() {
    this.$serviceBus.$off('validate', this.validate);
  },

  methods: {
    $hv__getFieldName(fieldPath, item) {
      return this.name || fieldPath;
    },
    $hv__getFieldLabel(fieldPath, item) {
      return (isEmpty(item.$params.label) ? null : item.$params.label.label) || this.label || this.name || fieldPath;
    },
    $hvalidate() {
      if (!isNil(this.$v)) this.$v.$touch();
    },
  },

  // .filter(it => it.name.indexOf('$') !== 0)
  // .filter(it => it.result === false)),
  computed: {
    __validations: function () {
      return this.$hv__createValidators(this.validate);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ValidateValueMixin.js